import { render, staticRenderFns } from "./FloatingButtons.vue?vue&type=template&id=0d615f7a&scoped=true&"
import script from "./FloatingButtons.vue?vue&type=script&lang=js&"
export * from "./FloatingButtons.vue?vue&type=script&lang=js&"
import style0 from "./FloatingButtons.vue?vue&type=style&index=0&id=0d615f7a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d615f7a",
  null
  
)

export default component.exports